import { render, staticRenderFns } from "./MarkingAssessmentList.vue?vue&type=template&id=4378304b&scoped=true&"
import script from "./MarkingAssessmentList.vue?vue&type=script&lang=js&"
export * from "./MarkingAssessmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378304b",
  null
  
)

export default component.exports